import ggl from 'graphql-tag';
import {
  ContentProcessingStatus,
  ContentProcessors,
} from '../../enums/ContentProcessingLogs';
import Interface from '../Interface';

export interface ContentProcessingLogsVars {
  id: string;
  processor: ContentProcessors;
}

interface ContentProcessingLogsData {
  getContentProcessingLogs: {
    status: ContentProcessingStatus;
  };
}

export default class ContentProcessingLogsInterface extends Interface {
  public async getContentProcessingLogs(variables: ContentProcessingLogsVars) {
    const response = await this.query<ContentProcessingLogsData>(
      () =>
        this.apolloService.executeQuery<ContentProcessingLogsData>({
          query: ggl`
            query getContentProcessingLogs($id: ID!, $processor: ContentProcessingLogProcessorEnum!) {
              getContentProcessingLogs(id: $id, processor: $processor) {
                status
              }
            }
          `,
          variables,
        }),
      'Error loading conversion status'
    );

    return response.getContentProcessingLogs;
  }
}
